import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const bigPanda = defineConnector({
  identifier: "bigPanda",
  name: "BigPanda",
  tagLine: "AIOps and event correlation",
  logo,
  protocol: "http",
  tags: ["it", "observability"],
  defaultUrlPattern: () => "https://api\\.bigpanda\\.io/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "In [BigPanda](https://www.bigpanda.io/), go to **Settings → API Keys** and create a new API key with the permissions you need.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.bigpanda.io/resources/v2.0/environments",
  },
});
